export const getBodyTopOffset = (): number => {
    const header = document.querySelector('header');
    const headerHeight = header?.getBoundingClientRect().height;
    return (headerHeight || 60) + 10;
};
